import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { hasMissingAssessmentText } from "../../../../formatting/sanitise-rich-text";
import Section from "../../common/Section/Section";
import type { AssessmentSectionComponentProps, Field } from "../../types";

function TextSection({ details, onEdit }: AssessmentSectionComponentProps) {
  const [selectedTab, setSelectedTab] = useState(0);
  const fields: Array<Field> = [
    {
      name: "About (short introduction)",
      type: "text",
      index: 0,
      fullLine: true,
      value: details.shortDescription,
    },
    {
      name: "SDG information",
      type: "text",
      index: 0,
      fullLine: true,
      richText: true,
      value: details.assessmentReport?.sdgInfo,
    },
    {
      name: "Developer information",
      type: "text",
      index: 0,
      fullLine: true,
      richText: true,
      value: details.assessmentReport?.developerInfo,
    },
    {
      name: "Monitoring information",
      type: "text",
      index: 0,
      fullLine: true,
      richText: true,
      value: details.assessmentReport?.monitoringInfo,
    },
    {
      name: "Location information",
      type: "text",
      index: 0,
      fullLine: true,
      richText: true,
      value: details.assessmentReport?.locationInfo,
    },
  ];

  return (
    <Section
      title="Text"
      columns={1}
      fields={[fields[selectedTab]]}
      onEdit={() => onEdit("text")}
      aboveFields={
        <Tabs
          value={selectedTab}
          onChange={(_event, value: number) => setSelectedTab(value)}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Assessment report text tabs"
          sx={{ mb: 3 }}
        >
          {fields.map((field) => (
            <Tab
              key={field.name}
              label={field.name}
              sx={{
                color: hasMissingAssessmentText(
                  field.value,
                  Boolean(field.richText),
                )
                  ? "error.main"
                  : undefined,
              }}
            />
          ))}
        </Tabs>
      }
    />
  );
}

export default TextSection;
